import { render, staticRenderFns } from "./VideoPC.vue?vue&type=template&id=5ca4c70d&"
import script from "./VideoPC.vue?vue&type=script&lang=js&"
export * from "./VideoPC.vue?vue&type=script&lang=js&"
import style0 from "./VideoPC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VideoPC.vue"
export default component.exports